import { userConstants } from './constantData';

export const LOGIN_DATA = {
  login_home: {
    page_view: {
      hash: 'p-010.011.000.000.000.000',
      event: 'pages',
      dimensions: ['v_client_id', 'v_language', 'v_app_name'],
    },
    enter_login: {
      hash: 'e-010.011.001.000.000.052',
      event: 'interactions',
      dimensions: ['v_client_id', 'v_language', 'v_app_name'],
    },
  },
  login_activation_options: {
    page_view: {
      hash: 'p-010.017.000.000.000.000',
      event: 'pages',
      dimensions: ['v_client_id', 'v_language', 'v_app_name'],
    },
    create_account: {
      hash: 'e-010.017.001.000.000.183',
      event: 'interactions',
      dimensions: ['v_client_id', 'v_language', 'v_app_name'],
    },
    pin_login_success: {
      hash: 'e-010.022.001.000.000.148',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  login_register: {
    page_view: {
      hash: 'p-010.148.000.000.000.000',
      event: 'pages',
      dimensions: ['v_client_id', 'v_language', 'v_app_name'],
    },
  },
};
